type FrontendConfig = {
  API_URL: string;
};

const developmentConfig: FrontendConfig = {
  API_URL: 'http://localhost:8090',
};

const productionConfig: FrontendConfig = {
  API_URL: 'https://internal-api.bserver.site',
};

const environmentConfig = import.meta.env.PROD ? productionConfig : developmentConfig;

export const config: FrontendConfig = {
  API_URL: import.meta.env.VITE_API_URL || environmentConfig.API_URL,
};
